/* Local dependencies */
import { PersonalData, PersonalDataErrors } from './types';

const REQUIRED_FIELD_ERROR = 'verification-field-required';
const REQUIRED_IMAGE_ERROR = 'verification-image-required';
export function validatePersonalData(personalData: PersonalData): PersonalDataErrors {
  const errors: PersonalDataErrors = {};
  const pin = personalData.pin.trim();
  const documentNumber = personalData.documentNumber.trim();

  if (!pin) {
    errors.pin = REQUIRED_FIELD_ERROR;
  }

  if (!documentNumber) {
    errors.documentNumber = REQUIRED_FIELD_ERROR;
  }

  if (!personalData.front) {
    errors.front = REQUIRED_IMAGE_ERROR;
  }

  if (!personalData.back) {
    errors.back = REQUIRED_IMAGE_ERROR;
  }

  if (!personalData.selfie) {
    errors.selfie = REQUIRED_IMAGE_ERROR;
  }

  return errors;
}
